export enum EnumTipoProduto {
  Produto = 0,
  Combo = 1,
  Insumo = 3,
  Servico = 4,
  Medicamento = 6
}
